import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';

export default function PostDraftCard({
  title,
  intro,
  onAddPlanned,
  buttonLabel,
}: {
  title: string;
  intro?: string;
  onAddPlanned: () => void;
  buttonLabel?: string;
}) {
  return (
    <div className="w-full">
      <Card className="border border-brand-green-border rounded-2xl p-4 shadow-sm">
        <h3 className="text-base font-semibold tracking-tight mb-2">{title}</h3>
        <div className="prose prose-sm max-w-none text-foreground/90">
          {(intro || '').split('\n').map((p, i) => (
            <p key={i} className={i > 0 ? 'mt-2' : ''}>{p}</p>
          ))}
        </div>
        <div className="mt-3">
          <Button
            size="sm"
            onClick={(e) => {
              console.log('PostDraftCard: Button clicked!', { title, onAddPlanned: !!onAddPlanned });
              e.preventDefault();
              e.stopPropagation();
              onAddPlanned();
            }}
            className="w-full bg-green-600 hover:bg-green-700 text-white"
            title="Writes the article in the background with an advanced GPT model and extensive research. You can check it later before posting"
          >
            {buttonLabel || 'Write about this topic'}
          </Button>
        </div>
      </Card>
    </div>
  );
}


